/* globals Namespace, Vue, jQuery */

import Vue from 'vue/dist/vue.js';

(function (ns, Vue, $) {
    'use strict';

    var URL = {
            MULTIPLE: '/api/schedule/v1.0/calendars/multipleFromDay'
        },
        VUE_LIST_APPOINTMENT = '.vue_listing_appointment',
        $availabilities = document.querySelectorAll(VUE_LIST_APPOINTMENT),
        START_APPOINTMENT = '#start_appointment',
        calendarIdArray = [];

    initAppointmentListing();

    /**
     * Initialize appointment listing behaviour
     */
    function initAppointmentListing() {
        if ($availabilities.length > 0) {
            $availabilities.forEach(saveCalendarId);
            if (calendarIdArray.toString().length) {
                getAvailabilities().then(instanceVueFunctionality);
            }
        }
    }

    /**
     * Save calendar Id in array
     * @param {Object} element
     */
    function saveCalendarId(element) {
        var calendarId = element.getAttribute('data-calendar-id');
        if (calendarId) {
            calendarIdArray.push(calendarId);
        }
    }

    /**
     * Get all list availabilities with one request. Calendar id are comma separated
     * @return {Promise}
     */
    function getAvailabilities() {
        return $.ajax({
            type: 'GET',
            data: {
                day: nextDayFormattedDate,
                numberOfDays: 60,
                onlyFreePeriods: 1,
                id: calendarIdArray.toString()
            },
            url: URL.MULTIPLE
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get next day date in 'yyyy-mm-dd' format
     * @return {string}
     */
    function nextDayFormattedDate() {
        var date = new Date(),
            TWO_DIGIT = 10,
            day, month, year;

        date.setDate(date.getDate() + 1);

        day = date.getUTCDate();
        month = date.getUTCMonth() + 1;
        year = date.getUTCFullYear();

        day = day < TWO_DIGIT ? '0' + day : day;
        month = month < TWO_DIGIT ? '0' + month : month;

        return year + '-' + month + '-' + day;
    }

    /**
     *
     * @param {Object} calendars
     */
    function instanceVueFunctionality(calendars) {
        var calendar;
        for (calendar in calendars) {
            if (calendars.hasOwnProperty(calendar) &&
                calendars[calendar].hasOwnProperty('isSynchronized') &&
                calendars[calendar].hasOwnProperty('freePeriods') &&
                calendars[calendar]['isSynchronized']) {
                refreshHours(calendar, calendars[calendar]['freePeriods']);
            }
        }
    }

    /**
     * Vue instance for listing availability summary
     * @param {String} calendarId
     * @param {Object} periods
     */
    function refreshHours(calendarId, periods) {
        var elSelector = VUE_LIST_APPOINTMENT + '[data-calendar-id="' + calendarId + '"]',
            element = document.querySelector(elSelector),
            companyUrl = element.getAttribute('data-url'),
            hqId = element.getAttribute('data-headquarter-id');

        new Vue({
            el: element,
            template: '#listing_availability_summary',
            data: function () {
                return {
                    isLoading: true,
                    periods: periods,
                    companyUrl: companyUrl
                };
            },
            mounted: function () {
                var TWO_SEC = 1000;
                setTimeout(this.hideLoading, TWO_SEC);
            },
            methods: {
                hideLoading: function () {
                    this.isLoading = false;
                },
                /**
                 * Navigate to company card and open start appointment modal
                 */
                showAvailabilities: function () {
                    this.trackAppointmentEvent('see_more_availabilities');
                    window.location = this.companyUrl + START_APPOINTMENT;
                },
                /**
                 * Request appointment through company card
                 * @param {Object} period
                 */
                requestAppointment: function (period) {
                    var params = {
                        'appointment_headquarter': hqId,
                        'appointment_start': period.start,
                        'appointment_end': period.end
                    };
                    this.trackAppointmentEvent('book_appointment_hour');
                    window.location = this.companyUrl + ns.utilities.objectToQueryString(params);
                },
                trackAppointmentEvent: function (label) {
                    if (window.hasOwnProperty('gaqTrackEvent')) {
                        window.gaqTrackEvent('CompanyList', 'go_company_card', label);
                    }
                }
            }
        });
    }

}(Namespace, Vue, jQuery));
